import { render, staticRenderFns } from "./CalledUserInfo.vue?vue&type=template&id=3222acdc&"
import script from "./CalledUserInfo.vue?vue&type=script&lang=js&"
export * from "./CalledUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports